/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import { API_ROUTES, API_URL, PermissionMenuKey } from "../../utils/constants";
import axios from "axios";
import LoadingCircle from "components/LoadingCircle/loadingCircle";

export default function GioThieu() {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({});

  useEffect(() => {
    const getDataGioiThieu = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(API_ROUTES.GIOITHIEU);
        setData(response.data?.data[0]);
        setIsLoading(false);
      } catch (error) {
        if (error.response && error.response.status === 500) {
          setAlert({
            alert: true,
            message: "Đã xảy ra lỗi 500. Vui lòng thử lại sau.",
            type: "error",
          });
        } else {
          console.log(error.response);
        }
        setIsLoading(false);
        return;
      }
    };
    getDataGioiThieu();
  }, []);

  return (
    <div className="bg-white py-4">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        {isLoading && (
          <div className="flex items-center justify-center mt-8">
            <LoadingCircle />
          </div>
        )}
        {!isLoading && data && data.length == 0 && (
          <div>Đang cập nhập tin tức. Vui lòng chờ trong giây lát!</div>
        )}
        <div className="border-b border-gray-300">
          <h5 className="text-md pb-4 font-bold tracking-tight text-gray-900">
            {data?.tieude}
          </h5>
        </div>
        <div
          dangerouslySetInnerHTML={{ __html: data?.noidung }}
          className="mb-4"
        />
      </div>
    </div>
  );
}
